<template>
<div>
    <h1 class="OTTitle OTTitle-left-side">
        <otif-icon icon="back" @click="goBack"/> {{ cachedJobName }}
    </h1>

    <ul class="list-unstyled OTlist OTlist-details-info OTlist-details-info-action">
        <li class="details-sub-separator"></li>

        <template v-if="startDisabled">
            <li class="details-sub-btn" v-b-tooltip.hover :title="startDisabledMessage">
                <otif-button id="OTsidebarStart" className="primary" @click.native="startJob(job)" :disabled="startDisabled">
                    <otif-icon icon="start"/> Start
                </otif-button>
            </li>
        </template>
        <template v-else>
            <li class="details-sub-btn">
                <otif-button id="OTsidebarStart" className="primary" @click.native="startJob(job)" :disabled="startDisabled">
                    <otif-icon icon="start"/> Start
                </otif-button>
            </li>
        </template>
        <li class="details-sub-btn" v-b-tooltip.hover :title="stopDisabledMessage" v-if="stopDisabled">
            <otif-button className="secondary" @click.native="stopJob(job)" :disabled="stopDisabled">
                <otif-icon icon="stop" /> Stop
            </otif-button>
        </li>
        <li class="details-sub-btn" v-else>
            <otif-button className="secondary" @click.native="stopJob(job)" :disabled="stopDisabled">
                <otif-icon icon="stop" /> Stop
            </otif-button>
        </li>
        <template v-if="resumeAvailable">
            <li class="details-sub-btn"  v-b-tooltip.hover :title="resumeDisabledMessage" v-if="resumeDisabled">
                <otif-button className="secondary" @click.native="resumeJob(job)" :disabled="resumeDisabled">
                    <otif-icon icon="resume" /> Resume
                </otif-button>
            </li>
            <li class="details-sub-btn" v-else>
                <otif-button className="secondary" @click.native="resumeJob(job)" :disabled="resumeDisabled">
                    <otif-icon icon="resume" /> Resume
                </otif-button>
            </li>
        </template>
        <li class="details-sub-btn">
            <otif-button className="secondary" @click.native="cloneJob(job)">
                <otif-icon icon="clone" /> Clone
            </otif-button>
        </li>
        <li class="details-sub-btn">
            <otif-button className="secondary" @click.native="deleteJob(job)" :disabled="deleteDisabled">
                Delete
            </otif-button>
        </li>
        </ul>
        <ul class="list-unstyled OTlist OTlist-details-info OTlist-details-info-status">
        <li>
            <span class="OTsidebarLabel">ID: </span> <span class="OTsidebarData">{{job.id}}</span>
        </li>
        <li>
            <span class="OTsidebarLabel">Type: </span> <span class="OTsidebarData">{{job.get('job_type')}}</span>

        </li>
        <li>
            <span class="OTsidebarLabel">Status: </span>
            <span class="OTstatus OTstatus-failed" v-if="jobError">
                {{job.attributes.status}} - reason: {{ jobErrorMsg }}
            </span>
            <span class="OTstatus" v-else>
                {{job.attributes.status}}
            </span>
        </li>
        </ul>
        <ul class="list-unstyled OTlist OTlist-details-info OTlist-details-info-extra">

        <li>
            <span class="OTsidebarLabel">Created On: </span>
            <span class="OTsidebarData">{{jobCreationDate}}</span>
            <span class="OTsidebarLabel">Created By: </span>
            <span class="OTsidebarData">{{job.get('created_by')}}</span>
        </li>
        <li>
            <span class="OTsidebarLabel">Modified On: </span>
            <span class="OTsidebarData">{{jobModifiedDate}}</span>
            <span class="OTsidebarLabel">Modified By: </span>
            <span class="OTsidebarData">{{job.get('modified_by') }}</span>
        </li>
        <li v-if="jobLastCompletedDate">
            <span class="OTsidebarLabel">Last Completed On: </span> <span class="OTsidebarData">{{jobLastCompletedDate}}</span>
        </li>
        <li v-if="schedulingEnabled">
            <span class="OTsidebarLabel">Scheduling:</span> <span class="OTsidebarData">Enabled</span>
        </li>
        <li v-else>
            <span class="OTsidebarLabel">Scheduling:</span> <span class="OTsidebarData">Disabled</span>
        </li>
        <li v-if="schedulingEnabled && cachedJobNextRunDate">
            <span class="OTsidebarLabel">Next Run Date:</span> <span class="OTsidebarData">{{cachedJobNextRunDate}}</span>
        </li>
        <li v-if="schedulingEnabled && cachedJobStartDate">
            <span class="OTsidebarLabel">Schedule Start Date:</span> <span class="OTsidebarData">{{cachedJobStartDate}}</span>
        </li>
        <li v-if="schedulingEnabled && cachedJobEndDate">
            <span class="OTsidebarLabel">Schedule End Date:</span> <span class="OTsidebarData">{{cachedJobEndDate}}</span>
        </li>
    </ul>


</div>
</template>

<script>

import JobActions from '../JobActions.vue'
import axios from 'axios';
import Moment from 'moment';

export default {

    mixins: [JobActions],

    data() {
        return {
            showConfirmDelete: false,
            showCloneJob: false,
            cloneJobName: '',
            startDisabled: true,
            startDisabledMessage: '',
            stopDisabled: true,
            stopDisabledMessage: '',
            resumeAvailable:false,
            resumeDisabled:true,
            resumeDisabledMessage:'',
            cachedJobName: '',
            cachedJobStartDate: '',
            cachedJobEndDate: '',
            cachedJobNextRunDate: '',
            schedulingEnabled: false
        }
    },

    props: ['job'],

    created() {

        this.updateCache();
        this.job.on('saved', this.updateCache);

        this.$eventBus.$on('job-started', () => {
            this.started();
        });
        this.$eventBus.$on('job-stopped', () => {
            this.stopped();
        });
    },

    beforeDestroy() {
        this.job.off('saved', this.updateCache);
    },

    computed: {
        jobCanStart() {
            return this.job.canStart();
        },

        jobCanStop() {
            return this.job.canStop();
        },

        deleteDisabled() {
            if (this.job.get('status') === 'Running') {
                return true;
            } else {
                return false;
            }
        },

        jobCreationDate() {
            return Moment(this.job.attributes.created_date, Moment.ISO_8601)
            .format('MMMM Do YYYY @ h:mma');
        },

        jobModifiedDate() {
            return Moment(this.job.attributes.modified_date, Moment.ISO_8601)
            .format('MMMM Do YYYY @ h:mma');
        },

        jobLastCompletedDate() {
            const date = this.job.get('last_run_date');
            if (date) {
                return Moment(date, Moment.ISO_8601)
                .format('MMMM Do YYYY @ h:mma');
            }
        },

        jobSchedule() {
            return '';
        },

        jobScheduleStartDate() {
            const date = this.job.get('start_date');
            if (date) {
                return Moment(date, Moment.ISO_8601)
                .format('MMMM Do YYYY @ h:mma');
            }
        },

        jobScheduleEndDate() {
            const date = this.job.get('end_date');
            if (date) {
                return Moment(date, Moment.ISO_8601)
                .format('MMMM Do YYYY @ h:mma');
            }
        },

        jobError() {
            if (this.job.get('status') == 'Failed') {
                return true;
            } else {
                return false;
            }
        },
        jobErrorMsg() {
            if (this.job.get('last_run_message')) {
                return this.job.get('last_run_message');
            }
        }
    },

    methods: {
 async isDocumentsExist(){             
      try {
        var baseUrl = "/mtm-gateway-api/v1/services/crawlers-admin";
        var url = baseUrl + "/ldc/";
        const res = await axios.get(url + this.job.id);        
        if (res.status >= 200 && res.status < 300) {
                 if(res.data.length>0){
                    this.startDisabled=false;
                }
           }
           if (this.job.get('status') === 'Running' ||
               this.job.get('status') === "Waiting" ) {              
               this.$store.state.localDocuments.isDisabled = 1;
            }else{
                 this.$store.state.localDocuments.isDisabled = 0;
            }
    
        }catch (err) {
        console.error(err);
      }
        },

        started() {
            this.startDisabled = true;
            this.stopDisabled = false;
        },

        stopped() {
            this.startDisabled = false;
            this.stopDisabled = true;
        },

        updateCache() {
           if(this.job.get('job_type')==='Local Documents') {
                this.isDocumentsExist();
           } else {           
           var bIsECM = this.job.get('job_type') === 'ECM';
           
            var canStart = this.job.canStart();
            if(canStart === true && bIsECM === true)
            {
                this.job.processECMTask('Check_Start').then((response) => {
                    if(response !== '')
                        canStart = response;
                    if (canStart === true) {
                        this.startDisabled = false;
                        this.startDisabledMessage = '';
                    } else {
                        this.startDisabled = true;
                        this.startDisabledMessage = canStart;
                    }
                });
            }
            else
            {
                if (canStart === true) {
                    this.startDisabled = false;
                    this.startDisabledMessage = '';
                } else {
                    this.startDisabled = true;
                    this.startDisabledMessage = canStart;
                }
            }
            var canStop = this.job.canStop();
            if(canStop === true && bIsECM === true)
            {
                this.job.processECMTask('Check_Stop').then((response) => {
                    if(response !== '')
                        canStop = response;
                    if (canStop === true) {
                        this.stopDisabled = false;
                        this.stopDisabledMessage = '';
                    } else {
                        this.stopDisabled = true;
                        this.stopDisabledMessage = canStop;
                    }
                });
            }
            else
            {
                if (canStop === true) {
                    this.stopDisabled = false;
                    this.stopDisabledMessage = '';
                } else {
                    this.stopDisabled = true;
                    this.stopDisabledMessage = canStop;
                }
            }
            if(bIsECM === true)
            {
                this.resumeAvailable = true;
                var bCanResume = this.job.canResume();
                if(bCanResume == true)
                {
                    this.job.processECMTask('Check_Resume').then((response) => {
                    if(response !== '')
                        bCanResume = response;
                    if (bCanResume === true) {
                        this.resumeDisabled = false;
                        this.resumeDisabledMessage = '';
                    } else {
                        this.resumeDisabled = true;
                        this.resumeDisabledMessage = bCanResume;
                    }
                });
                }
                else{
                     this.resumeDisabled = true;
                     this.resumeDisabledMessage = bCanResume;
                }
           }       
            else{
                this.resumeAvailable = false;
                this.resumeDisabled = true;
            }    
            
            this.cachedJobName = this.job.get('job_name');

            if (this.job.get('start_date')) {
                this.schedulingEnabled = true;
            } else {
                this.schedulingEnabled = false;
            }
           
        }
            const jobStartDate = this.job.get('start_date');
            if (jobStartDate) {
                this.cachedJobStartDate = Moment(jobStartDate, Moment.ISO_8601).format('MMMM Do YYYY @ h:mma');
            } else {
                this.cachedJobStartDate = '';
            }

            const jobEndDate = this.job.get('end_date');
            if (jobEndDate) {
                this.cachedJobEndDate = Moment(jobEndDate, Moment.ISO_8601).format('MMMM Do YYYY @ h:mma');
            } else {
                this.cachedJobEndDate = '';
            }

            const jobNextRunDate = this.job.get('next_run');
            if (jobNextRunDate) {
                this.cachedJobNextRunDate = Moment(jobNextRunDate, Moment.ISO_8601).format('MMMM Do YYYY @ h:mma');
            } else {
                this.cachedJobNextRunDate = '';
            }

        },

        goBack() {
            this.$router.push('/jobs');
        },

        deleteJob(job) {
            this.$eventBus.$emit('delete-job', job);
        },

        cloneJob(job) {
            this.$eventBus.$emit('clone-job', job);
        }
    }
}
</script>
